import { useEffect, useMemo, useState } from 'react'
import { workerTrainingStore } from '../services/workerTrainingStore'
import { WorkerCourse } from '../types/worker'

// Training records of one worker; empty when the worker is not saved yet
export function useWorkerTraining(workerId?: number): WorkerCourse[] {
  const [version, setVersion] = useState(workerTrainingStore.getVersion())

  useEffect(
    () =>
      workerTrainingStore.subscribe(() =>
        setVersion(workerTrainingStore.getVersion()),
      ),
    [],
  )

  return useMemo(
    () => (workerId === undefined ? [] : workerTrainingStore.getForWorker(workerId)),
    [workerId, version],
  )
}
